<template>
  <div id="app">
    <v-app id="inspire">
      
      <v-toolbar app class="blue">
        <v-toolbar-title class="ml-0 pl-3">
        <!--<v-toolbar-side-icon @click.stop="showDrawer = !showDrawer"></v-toolbar-side-icon>-->
        <span>Gruppen-Einteilung</span>
        </v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>
          <v-btn flat :to="{name: 'Projects'}">Projects</v-btn>
          <v-btn v-if="userLoggedIn()" flat :to="{name: 'UserDetail'}"><v-icon>account_circle</v-icon> Nutzer</v-btn>
          <v-btn v-else flat :to="{name: 'Login'}"><v-icon>account_circle</v-icon> Anmelden</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container fluid>
          <router-view/>
        </v-container>
      </v-content>
      <v-footer app></v-footer>
    </v-app>
  </div>
</template>
<script>
import {userLoggedIn} from '@/services/user.js';

import api from '@/services/user.js';
export default {
  data() {
    return {showDrawer: false, userLoggedIn: userLoggedIn }
  },
}
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
}
</style>
